export const configurationKeys = {
  all: ['configuration'] as const,
  businessLines: () => [...configurationKeys.all, 'businessLines'] as const,
  businessLine: (id: string) =>
    [...configurationKeys.businessLines(), id] as const,
  usersByBusinessLineId: (id: string) =>
    [...configurationKeys.businessLine(id), 'users'] as const,
  contracts: () => [...configurationKeys.all, 'contracts'] as const,
  contract: (id: string) => [...configurationKeys.contracts(), id] as const,
  products: () => [...configurationKeys.all, 'products'] as const,
  product: (id: string) => [...configurationKeys.products(), id] as const,
  channels: () => [...configurationKeys.all, 'channels'] as const,
  channel: (id: string) => [...configurationKeys.channels(), id] as const,
  landingFolderRestrictions: () =>
    [...configurationKeys.all, 'landingFolderRestrictions'] as const,
  landingFolderRestriction: (id: string) =>
    [...configurationKeys.landingFolderRestrictions(), id] as const,
  configurationsByType: (type: string) =>
    [...configurationKeys.all, 'type', type] as const,
  retentionPolicies: () =>
    [...configurationKeys.all, 'retentionPolicies'] as const,
  retentionPolicy: (id: string) =>
    [...configurationKeys.retentionPolicies(), id] as const,
};
